const { environment } = require('../baseSettings')

module.exports = {
  createAppointmentAfterPrepForm: [],
  disablePrepFormAutosave: [],
  validatePrepForm: [],
  allowClearPrepForm: false,
  minimalHeader: true,
  showAlert: false,
  showAlertHeader: false,
  requirePostCode: true,
  showConfirmationSubHeadline: true,
  editableAppointmentDetails: true,
  hidePhotoUploadSketch: true,
  allowFileUploadOptOut: true,
  useLoggedInCustomerData: true,
  requireCustomerAddress: true,
  useAmendCancel: true,
  useIndependentStyling: true,
  useRecaptcha: true,
  showTrustScore: true,
  verification: true,
  useTeamsOnlineMeeting: environment !== 'prod',
  showQrCodeVideoUpload: true,
  prepformProgressbar: true,
}
